'use client';

import type { PopoverProps } from '@heroui/react';
import { Popover as NextPopover, PopoverContent, PopoverTrigger } from '@heroui/react';
import type { ReactNode } from 'react';
import React from 'react';
type IPopoverProps = Omit<PopoverProps, 'children' | 'content'> & {
  children?: ReactNode;
  content?: ReactNode;
  trigger?: ReactNode;
};
export default function Popover({
  content,
  classNames,
  children,
  ...rest
}: IPopoverProps) {
  return <NextPopover classNames={{
    content: 'shadow-lg shadow-gray-300/40 border border-gray-100',
    ...classNames
  }} aria-label='Popover' {...rest} data-sentry-element="NextPopover" data-sentry-component="Popover" data-sentry-source-file="index.tsx">
      <PopoverTrigger aria-label='Popover' data-sentry-element="PopoverTrigger" data-sentry-source-file="index.tsx">
        <div>{children}</div>
      </PopoverTrigger>
      <PopoverContent className='rounded-lg' aria-label='Popover' data-sentry-element="PopoverContent" data-sentry-source-file="index.tsx">
        {content}
      </PopoverContent>
    </NextPopover>;
}